<template>
  <transition name="modal">
    <div class="modal common" @click="close()">
      <div class="modal-container" @click.stop="">
        <div class="common-content">
          <div class="text-content">
            <p>{{ message }}</p>
          </div>
          <div class="confirm-btn" @click="confirm()">確定</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'
import { modalOperate } from '@/plugins/operate/modal'

export default {
  name: 'commonBox',
  mixins: [modalOperate],
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    ...mapState({
      message: state => state.modal.message || {},
      callback: state => state.modal.callback
    })
  }
}
</script>

<style scoped>
</style>
